import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import store from '../store'


import bejelentkezes from '../views/bejelentkezes.vue'
import profil from '../views/profil.vue'


import admin from '../views/admin.vue'

import szilenciumibejegyzessablonok from '../views/szilenciumibejegyzessablonok'
import szilenciumibejegyzessablon from '../views/szilenciumibejegyzessablon'

import szilenciumfoglalas from '../views/szilenciumfoglalas.vue'
import szilenciumbejegyzes from '../views/szilenciumbejegyzes.vue'
import szilenciumjelenletiiv from '../views/szilenciumjelenletiiv.vue'
import szilenciumbejegyzesekmodositasa from '../views/szilenciumbejegyzesekmodositasa.vue'
import nemelegszilenciumotvalasztottak from '../views/nemelegszilenciumotvalasztottak.vue'
import szilenciumtelitettseg from '../views/szilenciumtelitettseg.vue'
import teremvalasztas from '../components/teremvalasztas.vue';


import szakkorok from '../views/szakkorok.vue'


import napiszobapontozas from '../views/napiszobapontozas.vue'
import hetiszobapontozasattekintes from '../views/hetiszobapontozasattekintes.vue'
import szobapontozaskimutatas from '../views/szobapontozaskimutatas.vue'

import informaciok from '../views/informaciok.vue'

import kiesbelepesek from '../views/kiesbelepesek.vue';
import kiesbelepesnaplo from '../views/kiesbelepesnaplo.vue';

import nyomtatas from '../views/nyomtatas.vue';

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/bejelentkezes',
    name: 'bejelentkezes',
    component: bejelentkezes
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/profil',
    name: 'profil',
    component: profil,
    meta: {bejelentkezesszukseges: true}
  },
  {
    path: '/admin',
    name: 'admin',
    component: admin,
    meta: {bejelentkezesszukseges: true, adminjogszukseges: true}
  },
  {
    path: '/szilenciumibejegyzessablonok',
    name: "szilenciumibejegyzessablonok",
    component: szilenciumibejegyzessablonok,
    meta: {bejelentkezesszukseges: true, adminjogszukseges: true}
  },
  {
    path: '/szilenciumibejegyzessablon/:id',
    name: "szilenciumibejegyzessablon",
    component: szilenciumibejegyzessablon,
    meta: {bejelentkezesszukseges: true, adminjogszukseges: true}
  },
  {
    path: '/szilenciumfoglalas',
    name: "szilenciumfoglalas",
    component: szilenciumfoglalas,
    meta: {bejelentkezesszukseges: true, neveloijogszukseges: true}
  },
  {
    path: '/szilenciumbejegyzes',
    name: "szilenciumbejegyzes",
    component: szilenciumbejegyzes,
    meta: {bejelentkezesszukseges: true, neveloijogszukseges: false}
  },
  {
    path: '/teremvalasztas/kollegista',
    name: 'teremvalasztasKollegista',
    component: teremvalasztas,
    meta: {bejelentkezesszukseges: true, neveloijogszukseges: false}
  },
  {
    path: '/szilenciumjelenletiiv',
    name: "szilenciumjelenletiiv",
    component: szilenciumjelenletiiv,
    meta: {bejelentkezesszukseges: true, neveloijogszukseges: true}
  },
  {
    path: '/szilenciumtelitettseg',
    name: "szilenciumtelitettseg",
    component: szilenciumtelitettseg,
    meta: {bejelentkezesszukseges: true, neveloijogszukseges: true}
  },
  {
    path: '/szilenciumbejegyzesekmodositasa',
    name: "szilenciumbejegyzesekmodositasa",
    component: szilenciumbejegyzesekmodositasa,
    meta: {bejelentkezesszukseges: true, neveloijogszukseges: true}
  },
  {
    path: '/nemelegszilenciumotvalasztottak',
    name: "nemelegszilenciumotvalasztottak",
    component: nemelegszilenciumotvalasztottak,
    meta: {bejelentkezesszukseges: true, neveloijogszukseges: true}
  },
  {
    path: '/szakkorok',
    name: "szakkorok",
    component: szakkorok,
    meta: {bejelentkezesszukseges: true, neveloijogszukseges: true}
  },
  {
    path: '/napiszobapontozas',
    name: "napiszobapontozas",
    component: napiszobapontozas,
    meta: {bejelentkezesszukseges: true, neveloijogszukseges: true}
  },
  {
    path: '/hetiszobapontozasattekintes',
    name: "hetiszobapontozasattekintes",
    component: hetiszobapontozasattekintes,
    meta: {bejelentkezesszukseges: true, neveloijogszukseges: true}
  },
  {
    path: '/szobapontozaskimutatas',
    name: "szobapontozaskimutatas",
    component: szobapontozaskimutatas,
    meta: {bejelentkezesszukseges: true, neveloijogszukseges: true}
  },
  {
    path: '/informaciok',
    name: "informaciok",
    component: informaciok,
    meta: {bejelentkezesszukseges: true, neveloijogszukseges: true}
  },
  {
    path: '/kiesbelepesek',
    name: "kiesbelepesek",
    component: kiesbelepesek,
    meta: {bejelentkezesszukseges: true, neveloijogszukseges: true}
  },
  {
    path: '/kiesbelepesnaplo',
    name: "kiesbelepesnaplo",
    component: kiesbelepesnaplo,
    meta: {bejelentkezesszukseges: true, neveloijogszukseges: true}
  },
  {
    path: '/nyomtatas',
    name: "nyomtatas",
    component: nyomtatas,
    meta: {bejelentkezesszukseges: true, neveloijogszukseges: true}
  }
]

const router = new VueRouter({
  mode: 'history',
  base: /*process.env.BASE_URL*/'/frontend/',
  routes
})
router.beforeEach((to, from, next) => {

    if(to.meta.bejelentkezesszukseges){
      if(store.state.bejelentkezve){
        if(to.meta.adminjogszukseges){
          if(store.state.minosites==-2){
            next();
          }
          else{
            next('/');
          }
        }
        else if(to.meta.neveloijogszukseges){
          if(store.state.minosites<0) next()
        }
        else {
          next();
        }
      }
      else{
        next('/');
      }
    }
    else{
      next();
    }

})

export default router
